import { FC, useState } from 'react'
import styled from '@emotion/styled'
import { Shapes } from 'src/components/theme'
import { UnavailableCardContent } from 'src/components/insights/unavailable-card-content'
import { TitleValueRow } from 'src/components/insights/zoning/key-value'
import { FANCY_SCROLLBAR } from 'src/utils/styles'

import { ZoneDetailResponse } from 'src/common-services/types/zone-types'

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${Shapes.spacing[4]}px;
  max-height: 450px;
  overflow-y: auto;
  ${FANCY_SCROLLBAR}
`
const EmptyWrapper = styled.div`
  flex: 1;
  align-items: stretch;
  div:first-of-type {
    height: 100%;
    padding: 0;
  }
`
type ZoningDetailsListProps = {
  details?: ZoneDetailResponse
}

export const ZoningDetailsList: FC<ZoningDetailsListProps> = ({ details }) => {
  const [isEmpty, setIsEmpty] = useState(true)

  if (!details) {
    return null
  }

  return (
    <Wrapper>
      {isEmpty && (
        <EmptyWrapper>
          <UnavailableCardContent message="No Zoning Details Available" />
        </EmptyWrapper>
      )}
      <TitleValueRow
        title={'Zone Code'}
        value={details.zone_details.zone_code}
        isEmpty={isEmpty}
        setIsEmpty={setIsEmpty}
      />
      <TitleValueRow
        title={'Zone Name'}
        value={details.zone_details.zone_name}
        isEmpty={isEmpty}
        setIsEmpty={setIsEmpty}
      />
      <TitleValueRow
        title={'Zone SubType'}
        value={details.zone_details.zone_sub_type}
        isEmpty={isEmpty}
        setIsEmpty={setIsEmpty}
      />
      <TitleValueRow
        title={'Zone Type'}
        value={details.zone_details.zone_type}
        isEmpty={isEmpty}
        setIsEmpty={setIsEmpty}
      />
      {/* <TitleValueRow
        title={'Permitted Family Types'}
        value={permittedFamilyTypes}
        isEmpty={isEmpty}
        setIsEmpty={setIsEmpty}
      /> */}
      <TitleValueRow
        title={'Zoning Guide'}
        value={details.zone_details.zone_guide || ''}
        isEmpty={isEmpty}
        setIsEmpty={setIsEmpty}
      />
      <TitleValueRow
        title={'County Zoning Link'}
        value={details.zone_details.link}
        isValueLink
        isEmpty={isEmpty}
        setIsEmpty={setIsEmpty}
      />
    </Wrapper>
  )
}
